export default __webpack_public_path__ + "static/media/56.a71de7e2.jpeg";